import { CSSProperties, FC, useRef, useState } from "react";
import styles from "./terms-item.module.css";
import { SubTermGroup } from "../../entities/terms-and-conditions.entities";

interface TermsItemProps {
  subTermGroup?: SubTermGroup;
  className?: string;
}

const TermsItem: FC<TermsItemProps> = ({ subTermGroup, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleOpen = () => {
    setIsOpen((o) => !o);
  };

  return (
    <div
      className={`${styles.wrapper} ${className} ${
      isOpen ? styles.open : styles.close
      }`}
      style={(
      {
        "--max-height": `${ref.current?.scrollHeight || 0}px`
      } as CSSProperties)}>


      <div className={styles.head} onClick={handleToggleOpen}>
        <div className={styles.text}>{subTermGroup?.title}</div>
        <span className={`icon-arrow ${styles.arrow}`} />
      </div>
      <div ref={ref} className={styles.expansible}>
        {subTermGroup?.questions.map((question) =>
        <div key={`question-${question.description}`} className={styles.item}>
            <div className={styles.itemTitle}>{question.description}</div>
            <div className={styles.itemAnswer}>{question.answer}</div>
          </div>
        )}
      </div>
    </div>);

};

export default TermsItem;